/* eslint-disable react/prop-types */
/* eslint-disable react/state-in-constructor */
import React, { PureComponent } from 'react';
import { Item, Segment, Image, Popup } from 'semantic-ui-react';
import { shape, string } from 'prop-types';
import { connect } from 'react-redux';
import EMCPreview from 'Assets/images/pages/web-chat/emc-preview.png';
import PrescriptionPreview from 'Assets/images/pages/web-chat/prescription-preview.png';
import * as Actions from 'Redux/modules/webChat/contextMenu/actions';
import {
  MESSAGE_TYPE_ATTACHMENT,
  MESSAGE_TYPE_MEDIA,
  MESSAGE_TYPE_TEXT,
} from 'Constants/message-types';
import moment from 'moment';
import PrivateImage from 'Modules/PrivateImage/PrivateImage';

import styles from './MessageBot.less';

const EMC_FORWARD = 'action_forward_emc';
const PRESCRIPTION_VIEW = 'view_prescription';

const ContentBotActions = ({ type, title }) => {
  switch (type) {
    case EMC_FORWARD:
      return (
        <>
          <div className={styles.preview}>
            <Image size="small" src={EMCPreview} />
          </div>
          Download this medical certificate
        </>
      );
    case PRESCRIPTION_VIEW:
      return (
        <>
          <div className={styles.preview}>
            <Image size="small" src={PrescriptionPreview} />
          </div>
          Download this prescription
        </>
      );
    default:
      return title;
  }
};

ContentBotActions.propTypes = {
  type: string.isRequired,
  title: string.isRequired,
};

const ContentBot = ({ type, message, sentAt }) => {
  switch (type) {
    case MESSAGE_TYPE_ATTACHMENT: {
      const {
        attachment: { body, content = [] },
      } = message;

      return (
        <>
          <Popup
            trigger={<div className="bot-body">{body}</div>}
            content={moment(sentAt).format('MMM DD - HH:mm').toUpperCase()}
            inverted
            size="tiny"
            position="top center"
            disabled
          />

          {content.map(item => (
            <div className="bot-content" key={item.title}>
              <div className="bot-title">{item.title}</div>
              <div className="bot-body">{item.body}</div>
              <div>
                {item.media &&
                  item.media.map(i => (
                    <div key={i.id} className="image">
                      <PrivateImage type="thumbnail" src={i.previewPath} />
                    </div>
                  ))}
              </div>
            </div>
          ))}
        </>
      );
    }
    case MESSAGE_TYPE_TEXT:
      return <div>{message.text}</div>;
    case MESSAGE_TYPE_MEDIA: {
      const { files } = message;
      return files && files.map(file => <PrivateImage src={file.previewPath} />);
    }
    default:
      return null;
  }
};

ContentBot.propTypes = {
  message: shape({}).isRequired,
  type: string.isRequired,
};

class MessageBot extends PureComponent {
  render() {
    const {
      message: { type, message, id, sentAt },
    } = this.props;
    return (
      <Item id={id}>
        <Item.Content className="bot">
          <Item.Description as={Segment}>
            <ContentBot type={type} message={message} sentAt={sentAt} />
          </Item.Description>
        </Item.Content>
      </Item>
    );
  }
}

MessageBot.propTypes = {
  message: shape({
    createdAt: string,
  }),
};
MessageBot.defaultProps = {
  message: {},
};

const mapStateToProps = state => ({
  token: state.auth.data.token,
  contextMenu: state.webChat.contextMenu,
});

const mapDispatchToProps = dispatch => ({
  changeContextMenu: (type, data) => dispatch(Actions.contextMenuChange({ type, data })),
  closeContextMenu: () => dispatch(Actions.contextMenuHide()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MessageBot);
